export type DocSlug =
  | "getting-started"
  | "install"
  | "export-pdfs"
  | "bulk"
  | "history"
  | "receipts"
  | "billing"
  | "security";

export type DocArticle = {
  slug: DocSlug;
  title: string;
  lead: string;
};

export const DOC_ARTICLES: readonly DocArticle[] = [
  { slug: "getting-started", title: "Getting started", lead: "" },
  {
    slug: "install",
    title: "Install",
    lead: "Install InvoiceVault from Stripe Marketplace, then open it from the Dashboard apps drawer. Click any link in the drawer to sign in securely via Stripe — you're redirected to the web app automatically. No separate account or password.",
  },
  {
    slug: "export-pdfs",
    title: "Invoice PDFs",
    lead: "Search invoices, select the rows you need, and export to ZIP — best for smaller batches on the current page or a short selection. Download finished files from Export History.",
  },
  {
    slug: "bulk",
    title: "Bulk export",
    lead: "Pro plan. Set search filters and export all matching invoice PDFs in one background job — built for high volume, up to hundreds of thousands of PDFs, split into multiple ZIP files. Track progress and download from Export History.",
  },
  {
    slug: "history",
    title: "Export History",
    lead: "Track every export job — status, filters used, and download links for each ZIP volume. Download links expire after 15 minutes; finished ZIP files are kept for 15 days, then deleted automatically.",
  },
  {
    slug: "receipts",
    title: "Receipts & CN",
    lead: "Available on Starter. Export payment receipt and credit note PDFs using the same flows as invoices — search and select rows for smaller batches. Bulk Export for large filtered invoice jobs is Pro.",
  },
  {
    slug: "billing",
    title: "Billing",
    lead: "Starter is free on install and includes downloads and list exports. Pro is $10/mo and unlocks Bulk Export Invoice PDFs — payments run through Stripe. Canceling stops next month's renewal; the current month stays active.",
  },
  {
    slug: "security",
    title: "Security",
    lead: "Invoice PDF content is not stored in our database — only export job metadata. Finished ZIP files are stored encrypted in Google Cloud Storage with time-limited signed download URLs. See Legal for full retention and privacy details.",
  },
] as const;

export function isDocSlug(value: string): value is DocSlug {
  return DOC_ARTICLES.some((article) => article.slug === value);
}
